module.exports = __webpack_public_path__ + "static/media/pers-4.d51f3581.jpg";